import { environmentGroupForBotSelector } from '@features/serverBots/selectors/environmentGroupForBotSelector'

import { RootState } from '../../../reducers'
import { EnvironmentGroupDescriptor } from '../types'
import { openBotIdSelector } from '../../../store/app/selectors'

export const environmentGroupForCurrentBotSelector = (
  state: RootState
): EnvironmentGroupDescriptor => {
  const currentBotId = openBotIdSelector(state)

  return environmentGroupForBotSelector(currentBotId)(state)
}
